/* MCR premium core: reveal animations, wishlist store, toasts, modals, scroll UI, prefetch.
   Public API: window.MCR = { wishlist, toast, modal, reveal } */
(function () {
  'use strict';
  if (window.MCR) return;
  var cfg = window.MCRConfig || {};
  var doc = document;
  var root = doc.documentElement;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Toast ---------- */
  function toast(message, opts) {
    opts = opts || {};
    var region = doc.querySelector('.mcr-toast-region');
    if (!region) {
      region = doc.createElement('div');
      region.className = 'mcr-toast-region';
      region.setAttribute('role', 'status');
      region.setAttribute('aria-live', 'polite');
      doc.body.appendChild(region);
    }
    var el = doc.createElement('div');
    el.className = 'mcr-toast';
    el.textContent = message;
    if (opts.linkUrl && opts.linkText) {
      var a = doc.createElement('a');
      a.href = opts.linkUrl;
      a.textContent = opts.linkText;
      el.appendChild(a);
    }
    region.appendChild(el);
    setTimeout(function () {
      el.classList.add('is-leaving');
      setTimeout(function () { el.remove(); }, 320);
    }, opts.duration || 2800);
  }

  /* ---------- Wishlist (localStorage, keyed by product handle) ---------- */
  var WL_KEY = 'mcr:wishlist:v1';
  function read() {
    try { return JSON.parse(localStorage.getItem(WL_KEY)) || []; } catch (e) { return memory; }
  }
  var memory = [];
  function write(list) {
    memory = list;
    try { localStorage.setItem(WL_KEY, JSON.stringify(list)); } catch (e) {}
    sync();
    doc.dispatchEvent(new CustomEvent('mcr:wishlist:change', { detail: { items: list.slice() } }));
  }
  var wishlist = {
    all: function () { return read(); },
    has: function (h) { return read().indexOf(h) > -1; },
    add: function (h) { var l = read(); if (l.indexOf(h) === -1) { l.unshift(h); write(l); } },
    remove: function (h) { write(read().filter(function (x) { return x !== h; })); },
    clear: function () { write([]); },
    toggle: function (h) {
      var on = !wishlist.has(h);
      on ? wishlist.add(h) : wishlist.remove(h);
      return on;
    },
  };
  function sync() {
    var list = read();
    doc.querySelectorAll('[data-mcr-wishlist]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', list.indexOf(btn.getAttribute('data-mcr-wishlist')) > -1 ? 'true' : 'false');
    });
    doc.querySelectorAll('[data-mcr-wishlist-count]').forEach(function (el) {
      el.textContent = list.length ? String(list.length) : '';
      el.setAttribute('data-count', String(list.length));
    });
  }
  doc.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-mcr-wishlist]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var on = wishlist.toggle(btn.getAttribute('data-mcr-wishlist'));
    btn.classList.remove('is-bursting');
    void btn.offsetWidth;
    if (on) btn.classList.add('is-bursting');
    toast(on ? cfg.wishlistAdded || 'Saved to your wishlist' : cfg.wishlistRemoved || 'Removed from your wishlist', {
      linkUrl: on ? cfg.wishlistUrl : null,
      linkText: cfg.wishlistViewText || 'View',
    });
  });
  // keep tabs in sync
  window.addEventListener('storage', function (e) { if (e.key === WL_KEY) sync(); });

  /* ---------- Reveal on scroll ---------- */
  function splitWords(el) {
    if (el.dataset.mcrSplitDone) return;
    el.dataset.mcrSplitDone = '1';
    var words = el.textContent.trim().split(/\s+/);
    // keep inner markup (em etc.) intact when present
    if (el.children.length) return;
    el.innerHTML = words
      .map(function (w, i) { return '<span class="mcr-word"><span style="--mcr-w:' + i + '">' + w.replace(/</g, '&lt;') + '</span></span>'; })
      .join(' ');
  }
  var io =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-revealed');
                io.unobserve(entry.target);
              }
            });
          },
          { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
        )
      : null;
  function reveal(scope) {
    scope = scope || doc;
    scope.querySelectorAll('[data-mcr-split]').forEach(splitWords);
    scope.querySelectorAll('[data-mcr-reveal], [data-mcr-split]').forEach(function (el) {
      if (el.classList.contains('is-revealed')) return;
      if (!io || reduceMotion || !root.classList.contains('mcr-anim')) return el.classList.add('is-revealed');
      io.observe(el);
    });
    // stagger children: data-mcr-stagger on parent sets --mcr-i
    scope.querySelectorAll('[data-mcr-stagger]').forEach(function (p) {
      Array.prototype.forEach.call(p.children, function (c, i) { c.style.setProperty('--mcr-i', i % 8); });
    });
  }

  /* ---------- Lazy images fade-in ---------- */
  function lazyFade(scope) {
    (scope || doc).querySelectorAll('img.mcr-lazy').forEach(function (img) {
      if (img.complete) img.classList.add('is-loaded');
      else img.addEventListener('load', function () { img.classList.add('is-loaded'); }, { once: true });
    });
  }

  /* ---------- Lazy videos: <video data-mcr-lazy-video> with <source data-src> ---------- */
  var vio =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              var v = entry.target;
              if (entry.isIntersecting) {
                if (!v.dataset.loaded) {
                  v.querySelectorAll('source[data-src]').forEach(function (s) { s.src = s.dataset.src; });
                  v.load();
                  v.dataset.loaded = '1';
                }
                if (v.hasAttribute('data-autoplay') && !reduceMotion) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
              } else if (!v.paused) {
                v.pause();
              }
            });
          },
          { rootMargin: '200px 0px' }
        )
      : null;
  function lazyVideos(scope) {
    (scope || doc).querySelectorAll('video[data-mcr-lazy-video]').forEach(function (v) {
      if (vio) vio.observe(v);
      else v.querySelectorAll('source[data-src]').forEach(function (s) { s.src = s.dataset.src; });
    });
  }

  /* ---------- Modal: [data-mcr-modal-open="id"] opens <div class="mcr-modal" id="id"> ---------- */
  var lastFocus = null;
  var modal = {
    open: function (id) {
      var m = doc.getElementById(id);
      if (!m) return;
      lastFocus = doc.activeElement;
      m.classList.add('is-open');
      m.setAttribute('aria-hidden', 'false');
      root.classList.add('mcr-lock');
      var f = m.querySelector('.mcr-modal__close, button, a, input');
      if (f) f.focus();
      m.dispatchEvent(new CustomEvent('mcr:modal:open', { bubbles: true }));
    },
    close: function (m) {
      m = m || doc.querySelector('.mcr-modal.is-open');
      if (!m) return;
      m.classList.remove('is-open');
      m.setAttribute('aria-hidden', 'true');
      if (!doc.querySelector('.mcr-modal.is-open')) root.classList.remove('mcr-lock');
      if (lastFocus) lastFocus.focus();
    },
  };
  doc.addEventListener('click', function (e) {
    var o = e.target.closest && e.target.closest('[data-mcr-modal-open]');
    if (o) { e.preventDefault(); modal.open(o.getAttribute('data-mcr-modal-open')); return; }
    var c = e.target.closest && e.target.closest('[data-mcr-modal-close]');
    if (c) { e.preventDefault(); modal.close(c.closest('.mcr-modal')); }
  });
  doc.addEventListener('keydown', function (e) { if (e.key === 'Escape') modal.close(); });

  /* ---------- Scroll progress + back to top ---------- */
  function scrollUI() {
    var bar = cfg.scrollProgress ? doc.createElement('div') : null;
    if (bar) { bar.className = 'mcr-progress'; bar.setAttribute('aria-hidden', 'true'); doc.body.appendChild(bar); }
    var top = null;
    if (cfg.backToTop) {
      top = doc.createElement('button');
      top.type = 'button';
      top.className = 'mcr-to-top';
      top.setAttribute('aria-label', cfg.backToTopLabel || 'Back to top');
      top.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
      top.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' }); });
      doc.body.appendChild(top);
    }
    if (!bar && !top) return;
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var h = doc.documentElement.scrollHeight - window.innerHeight;
        var y = window.pageYOffset;
        if (bar) bar.style.setProperty('--mcr-progress', h > 0 ? (y / h).toFixed(4) : 0);
        if (top) top.classList.toggle('is-visible', y > window.innerHeight * 1.2);
        ticking = false;
      });
    }, { passive: true });
  }

  /* ---------- Hover prefetch ---------- */
  function prefetch() {
    if (!cfg.instantLinks) return;
    var link = doc.createElement('link');
    if (!(link.relList && link.relList.supports && link.relList.supports('prefetch'))) return;
    var done = {};
    var conn = navigator.connection;
    if (conn && (conn.saveData || /2g/.test(conn.effectiveType || ''))) return;
    doc.addEventListener('mouseover', function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || a.origin !== location.origin || done[a.href] || a.hasAttribute('data-no-prefetch')) return;
      if (/\/(cart|checkout|account)/.test(a.pathname) || a.hash) return;
      done[a.href] = true;
      var l = doc.createElement('link');
      l.rel = 'prefetch';
      l.href = a.href;
      doc.head.appendChild(l);
    }, { passive: true });
  }

  function init(scope) {
    reveal(scope);
    lazyFade(scope);
    lazyVideos(scope);
    sync();
  }

  window.MCR = { wishlist: wishlist, wishlistSync: sync, toast: toast, modal: modal, reveal: reveal, init: init, config: cfg };

  function boot() {
    init(doc);
    scrollUI();
    prefetch();
    doc.dispatchEvent(new CustomEvent('mcr:ready'));
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Theme editor support
  doc.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
